/** UAがLINEのWebViewかどうか */
export const isLineWebview = (userAgent?: string): boolean => /\bline\b/i.test(userAgent ?? '');
